import _capitalize from "lodash/capitalize";
import { BulbIcon, CheckmarkIcon, CodeIcon, CrossCircleIcon, CrossCircleInvertedIcon } from '@datacamp/waffles-icons';
import { colors } from '@datacamp/waffles-tokens';
import cx from 'classnames';
import React from 'react';
import { appendClassSuffix } from './utils';
var TabIconByMessageType = {
  ASSISTANT: /*#__PURE__*/React.createElement(CrossCircleInvertedIcon, {
    "aria-hidden": true,
    color: "#FF5400"
  }),
  CORRECT: /*#__PURE__*/React.createElement(CheckmarkIcon, {
    "aria-hidden": true,
    color: colors.green
  }),
  HINT: /*#__PURE__*/React.createElement(BulbIcon, {
    "aria-hidden": true,
    color: colors.navy
  }),
  INCORRECT: /*#__PURE__*/React.createElement(CrossCircleIcon, {
    "aria-hidden": true,
    color: colors.orange
  }),
  SOLUTION: /*#__PURE__*/React.createElement(CodeIcon, {
    "aria-hidden": true,
    color: colors.navy
  })
};
export var getTabIcon = function getTabIcon(feedbackMessageType) {
  return TabIconByMessageType[feedbackMessageType];
};

var Tab = function Tab(_ref) {
  var feedbackMessage = _ref.feedbackMessage,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("li", {
    className: "dc-sct-feedback__tab-container"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": _capitalize(feedbackMessage.messageType),
    className: cx('dc-sct-feedback__tab', appendClassSuffix('dc-sct-feedback__tab', feedbackMessage.messageType), {
      'dc-sct-feedback__tab--active': feedbackMessage.isActive
    }),
    onClick: onClick
  }, getTabIcon(feedbackMessage.messageType)));
};

var Tabs = function Tabs(_ref2) {
  var feedbackMessages = _ref2.feedbackMessages,
      onClickTab = _ref2.onClickTab;
  return /*#__PURE__*/React.createElement("ul", {
    className: "dc-sct-feedback__tab-list"
  }, feedbackMessages.map(function (feedbackMessage) {
    return /*#__PURE__*/React.createElement(Tab, {
      feedbackMessage: feedbackMessage,
      key: feedbackMessage.messageType + feedbackMessage.tabIndex.toString(),
      onClick: function onClick() {
        return onClickTab(feedbackMessage.tabIndex);
      }
    });
  }));
};

export default Tabs;